import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowTextBlockConfigSchema = z.object({ text: z.string().max(2_500_000) });
export const FlowTextBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Text),
    config: FlowTextBlockConfigSchema,
});
//# sourceMappingURL=config.js.map